import { ROUTE_CHECKOUT } from '../constants';
import { buildOrderPlacedPayload } from '../helpers/brazeHelper';
import { withItemsPayload } from './pulseItemsPayload';
import { trackImmediate } from './pulseTracker';
import type { PulseEventPartial } from './pulseSchema';
import { PULSE_VIEW_ID } from './pulseViewIds';
import {
  clearCheckoutIdSession,
  resolveCheckoutIdForPurchase,
} from './pulseCheckoutId';

const toAmount = (value: unknown): number | null => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
};

export const buildPurchasePulsePartial = (
  orderId: string | number,
  order: any,
  isItMobile: boolean,
  page_path?: string
): PulseEventPartial => {
  const orderPlacedPayload = buildOrderPlacedPayload(orderId, order, isItMobile);

  const deliveryFee = Number(orderPlacedPayload.deliveryFee ?? 0);
  const serviceFee = Number(orderPlacedPayload.serviceFee ?? 0);
  const tipAmount = Number(orderPlacedPayload.tipAmount ?? 0);
  const transactionTotal =
    Number(orderPlacedPayload.total ?? 0) +
    (Number.isFinite(tipAmount) ? tipAmount : 0);
  const cartId = order?.cart_id ?? order?.cartId ?? null;
  const checkout_id = resolveCheckoutIdForPurchase(cartId);
  clearCheckoutIdSession();

  return {
    event_name: 'purchase',
    view_id: PULSE_VIEW_ID.CHECKOUT,
    page_path:
      page_path ??
      (typeof window !== 'undefined'
        ? window.location.pathname
        : ROUTE_CHECKOUT),
    conversion_id: orderId ?? null,
    cart_id: cartId,
    checkout_id,
    ...withItemsPayload({ items: orderPlacedPayload.items }),
    // Same key Billing shows as Subtotal on a placed order.
    sub_total_amount: toAmount(order?.gross_sales),
    tax_amount: toAmount(orderPlacedPayload.tax ?? 0),
    tip: toAmount(tipAmount),
    transaction_amount: toAmount(transactionTotal),
    delivery_amount: deliveryFee > 0 ? deliveryFee : null,
    service_amount: serviceFee > 0 ? serviceFee : null,
    action: 'purchase',
  };
};

/** Pulse `purchase` — immediate send. */
export const trackPurchase = (
  orderId: string | number,
  order: any,
  isItMobile: boolean,
  page_path?: string
): void => {
  trackImmediate(
    buildPurchasePulsePartial(orderId, order, isItMobile, page_path)
  );
};
